<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>

<script>
import echarts from "echarts";
import { onMounted, ref, watch, watchEffect } from "vue";
export default {
  props: {
    statistics: {
      type: Object,
    },
    xAxis: Array,
    dataName: {
      type: Array,
    },
    series: Array,
  },
  name: "line_charts",
  setup(props) {
    const charts = ref();
    onMounted(() => {
      const chart = charts.value;
      if (chart) {
        var myChart = echarts.init(chart);
     
        var option = {
          tooltip: { trigger: "axis" },
          xAxis: {
            type: "category",
            data: props.xAxis,
            boundaryGap: false, //坐标轴两边不留白
          },
          yAxis: {
            type: "value",
          },
          legend: {               //设置区分（哪条线属于什么）
            data: props.dataName
          },
          series: props.series,
        };
        myChart.setOption(option);
        watch(props, () => {
          myChart.setOption({
            series: props.series,
            xAxis: {
              type: "category",
              data: props.xAxis,
              boundaryGap: false, //坐标轴两边不留白
            },
          });
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        });
      }
    });
    return {
      charts,
    };
  },
};
</script>